let obj = {
  addresOptions: [{
    "addres": "天津",
    "bsName": "紫金财产保险股份有限公司天津分公司",
    "children": [{
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "天津南"
    }, {
      "fgs": "天津北"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "中信银行和平支行",
		"seatNumber": "8111401412900110406",
    "flightArrcode": "litao@zking.com"
  }, {
    "addres": "石家庄",
    "bsName": "紫金财产保险股份有限公司河北分公司",
    "children": [{
      "fgs": "石家庄"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司河北分公司/中国银行石家庄市裕东支行营业部",
		"seatNumber": "100841581839",
    "flightArrcode": "zhaobaoke@zking.com"
  }, {
    "addres": "徐州",
    "bsName": "紫金财产保险股份有限公司徐州中心支公司",
    "children": [{
      "fgs": "徐州"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司徐州中心支公司/江苏银行徐州科技支行",
		"seatNumber": "60200188000254978",
    "flightArrcode": "taoshuyong@zking.com"
  }, {
    "addres": "青岛",
    "bsName": "紫金财产保险股份有限公司青岛分公司",
    "children": [{
      "fgs": "青岛东"
    }, {
      "fgs": "青岛西"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司青岛分公司/农行青岛分行营业部",
		"seatNumber": "38010101040025219",
    "flightArrcode": "wujianan@zking.com"
  }, {
    "addres": "济南",
    "bsName": "紫金财产保险股份有限公司济南中心支公司",
    "children": [{
      "fgs": "济南"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司济南中心支公司—中国工商银行济南趵突泉支行",
		"seatNumber": "1602023909200093280",
    "flightArrcode": "liuchao@zking.com"
  }, {
    "addres": "苏州",
    "bsName": "紫金财产保险股份有限公司昆山支公司",
    "children": [{
      "fgs": "苏州南"
    }, {
      "fgs": "苏州中"
    }, {
      "fgs": "苏州东"
    }, {
      "fgs": "苏州北"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司苏州分公司/中国农业银行股份有限公司苏州吴中支行",
		"seatNumber": "10538301040009329",
    "flightArrcode": "zhangyang003@zking.com"
  }, {
    "addres": "无锡",
    "bsName": "紫金财产保险股份有限公司梁溪支公司",
    "children": [{
      "fgs": "无锡南"
    }, {
      "fgs": "无锡北"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司无锡分公司/农业银行无锡分行营业部",
		"seatNumber": "10630001040003796",
    "flightArrcode": ""
  }, {
    "addres": "南通",
    "bsName": "紫金财产保险股份有限公司南通中心支公司",
    "children": [{
      "fgs": "南通"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司南通中心支公司/中国农业银行南通濠西支行",
		"seatNumber": "10708201040008731",
    "flightArrcode": "jihongfei@zking.com"
  }, {
    "addres": "上海",
    "bsName": "紫金财产保险股份有限公司上海分公司",
    "children": [{
      "fgs": "上海市南"
    }, {
      "fgs": "上海市北"
    }, {
      "fgs": "上海市东"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }, {
      "fgs": ""
    }],
    "pieces": "紫金财产保险股份有限公司上海分公司",
		"seatNumber": "",
    "flightArrcode": "liukai@zking.com"
  }, {
    "addres": "扬州",
    "bsName": "紫金财产保险股份有限公司仪征支公司",
    "children": [{
      "fgs": "扬州"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司扬州中心支公司/中国农业银行扬州新区支行",
		"seatNumber": "10157401040064470",
    "flightArrcode": "rongyue@zking.com"
  }, {
    "addres": "合肥",
    "bsName": "紫金财产保险股份有限公司安徽分公司",
    "children": [{
      "fgs": "合肥"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司安徽分公司/中行合肥四牌楼支行",
		"seatNumber": "178211566988",
    "flightArrcode": "zhanghaixia@zking.com"
  }, {
    "addres": "宁波",
    "bsName": "紫金财产保险股份有限公司浙江分公司",
    "children": [{
      "fgs": "宁波东"
    }, {
      "fgs": "宁波西"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "杭州分公司协助出单，后续提供对公账户/中行合肥四牌楼支行",
		"seatNumber": "",
    "flightArrcode": "lijie007@zking.com"
  }, {
    "addres": "杭州",
    "bsName": "紫金财产保险股份有限公司浙江分公司",
    "children": [{
      "fgs": "杭州南"
    }, {
      "fgs": "杭州北"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司浙江分公司/中国工商银行股份有限公司杭州众安支行",
		"seatNumber": "1202021719900072977",
    "flightArrcode": "lijie007@zking.com"
  }, {
    "addres": "台州",
    "bsName": "紫金财产保险股份有限公司台州中心支公司",
    "children": [{
      "fgs": "台州"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司台州中心支公司/中国工商银行台州市北门支行",
		"seatNumber": "1207231209201052553",
    "flightArrcode": "wangfeiping@zking.com"
  }, {
    "addres": "南宁",
    "bsName": "紫金财产保险股份有限公司广西分公司",
    "children": [{
      "fgs": "南宁"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司广西分公司",
		"seatNumber": "",
    "flightArrcode": "jianglifang01@zking.com"
  }, {
    "addres": "武汉",
    "bsName": "紫金财产保险股份有限公司湖北分公司",
    "children": [{
      "fgs": "武汉东"
    }, {
      "fgs": "武汉西"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司武昌营销服务部",
		"seatNumber": "",
    "flightArrcode": "wangqiang004@zking.com"
  }, {
    "addres": "郑州",
    "bsName": "紫金财产保险股份有限公司郑州支公司",
    "children": [{
      "fgs": "郑州"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司郑州中心支公司/工商银行郑州东区支行",
		"seatNumber": "1702021619200075569",
    "flightArrcode": "liujingwen001@zking.com"
  }, {
    "addres": "长沙",
    "bsName": "紫金财产保险股份有限公司湘江支公司",
    "children": [{
      "fgs": "长沙"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司湖南分公司/农行长沙市天心区支行营业部",
		"seatNumber": "18064401040001466",
    "flightArrcode": "liuning@zking.com"
  }, {
    "addres": "成都",
    "bsName": "紫金财产保险股份有限公司四川分公司 ",
    "children": [{
      "fgs": "成都"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司四川分公司",
		"seatNumber": "",
    "flightArrcode": "zhuyali@zking.com"
  }, {
    "addres": "西安",
    "bsName": "紫金财产保险股份有限公司陕西分公司",
    "children": [{
      "fgs": "西安"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司陕西分公司/招商银行股份有限公司西安枫林绿洲支行",
		"seatNumber": "129910457110502",
    "flightArrcode": "liuzhan@zking.com"
  }, {
    "addres": "北京",
    "bsName": "利宝保险有限公司北京分公司",
    "children": [{
      "fgs": "北京东"
    }, {
      "fgs": "北京西"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "",
		"seatNumber": "",
    "flightArrcode": ""
  }, {
    "addres": "保定",
    "bsName": "利宝保险有限公司河北分公司",
    "children": [{
      "fgs": "保定"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "利宝保险有限公司石家庄中心支公司/建设银行石家庄红旗大街支行",
		"seatNumber": "13050161560800000894",
    "flightArrcode": "abel.ji@libertymutual.com.cn"
  }, {
    "addres": "金华",
    "bsName": "利宝保险有限公司浙江分公司",
    "children": [{
      "fgs": "金华南"
    }, {
      "fgs": "金华北"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "利宝保险有限公司浙江分公司/建设杭州文三路支行",
		"seatNumber": "33001618135053002574",
    "flightArrcode": "nerissa.wu@libertymutual.com.cn"
  }, {
    "addres": "温州",
    "bsName": "利宝保险有限公司浙江分公司",
    "children": [{
      "fgs": "温州"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "利宝保险有限公司浙江分公司/建设杭州文三路支行",
		"seatNumber": "33001618135053002574",
    "flightArrcode": "nerissa.wu@libertymutual.com.cn"
  }, {
    "addres": "广州",
    "bsName": "紫金财产保险股份有限公司南沙支公司",
    "children": [{
      "fgs": "广州南"
    }, {
      "fgs": "广州北"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }],
    "pieces": "紫金财产保险股份有限公司广东分公司/中国农业银行股份有限公司广州珠江广场支行",
		"seatNumber": "44049901040011548",
    "flightArrcode": "liwanwen@zking.com"
  }, {
    "addres": "中山",
    "bsName": "紫金财产保险股份有限公司中山中心支公司",
    "children": [{
      "fgs": "中山"
    }, {
      "fgs": "汽租"
    }, {
      "fgs": "小车"
    }, {
      "fgs": "渠道"
    }, {
      "fgs": "微企"
    }, {
      "fgs": "供行一部"
    }, {
      "fgs": "供行二部"
    }, {
      "fgs": "供行三部"
    }, {
      "fgs": "营建一部"
    }, {
      "fgs": "营建二部"
    }, {
      "fgs": "营建三部"
    }, {
      "fgs": ""
    }, {
      "fgs": ""
    }],
    "pieces": "紫金财产保险股份有限公司中山中心支公司/中国工商银行广东省中山分行营业部",
		"seatNumber": "2011002519200160219",
    "flightArrcode": "fengtao@zking.com"
  }]
}

export default { ...obj }